import dayjs from 'dayjs';

import { AgentStatus, Cluster } from '@cast/types';

import { SUPPORTS_STORAGE } from 'constants/cluster';

export const isDisconnectedForMonth = (cluster: Cluster): boolean =>
  cluster.agentStatus === AgentStatus.DISCONNECTED &&
  dayjs(cluster.agentSnapshotReceivedAt).isBefore(dayjs().subtract(30, 'day'));

export const isStorageReportsSupported = ({ providerType }: Cluster): boolean =>
  SUPPORTS_STORAGE.includes(providerType);
